export enum MenuItemType {
    SEPARATOR, ITEM
}